export const ROUTE_HOME = {
  path: '/home',
  name: 'home',
};

export const ROUTE_ABOUT = {
  path: '/about',
  name: 'about',
};

export const ROUTE_SIGN_IN = {
  path: '/sing-in',
  name: 'sign-in',
};

export const ROUTE_PEDIDO = {
  path: '/pedido',
  name: 'pedido',
};

export const ROUTE_SINCRONIZAR = {
  path: '/sincronizar',
  name: 'sincronizar',
};

export const ROUTE_PRODUTOS = {
  path: '/produtos',
  name: 'produtos',
};

export const ROUTE_CLIENTES = {
  path: '/clientes',
  name: 'clientes',
};

export const ROUTE_CLIENTES_LISTA_PRECADASTRO = {
  path: '/listaprecadastro',
  name: 'listaprecadastro',
};

export const ROUTE_CLIENTES_PRECADASTRO = {
  path: '/precadastro',
  name: 'precadastro',
};

export const ROUTE_DIVERSOS = {
  path: '/diversos',
  name: 'diversos',
};

export const ROUTE_CADASTRO_PEDIDO = {
  path: '/cadastro-pedido',
  name: 'cadastro-pedido',
}

export const ROUTE_PESQUISA_CADASTRO_PEDIDO = {
  path: '/pesquisa-cadastro-pedido',
  name: 'pesquisa-cadastro-pedido',
}

export const ROUTE_PESQUISA_CADASTRO_CLIENTE = {
  path: '/pesquisa-cadastro-cliente',
  name: 'pesquisa-cadastro-cliente',
}

export const ROUTE_PESQUISA_FINANCEIRO_CLIENTE = {
  path: '/pesquisa-financeiro-cliente',
  name: 'pesquisa-financeiro-cliente',
}

export const ROUTE_PESQUISA_FILTRO_PRODUTO = {
  path: '/pesquisa-filtro-produto',
  name: 'pesquisa-filtro-produto',
}

export const ROUTE_CADASTRO_PEDIDO_ITEM = {
  path: '/cadastro-pedido-item',
  name: 'cadastro-pedido-item',
}

export const ROUTE_CADASTRO_PEDIDO_PRODUTO = {
  path: '/cadastro-pedido-produto',
  name: 'cadastro-pedido-produto',
}

export const ROUTE_PESQUISA_VISITA_CLIENTE = {
  path: '/pesquisa_visita_cliente',
  name: 'pesquisa_visita_cliente',
}

export const ROUTE_DIVERSOS_RESUMO = {
  path: '/diversos_resumo',
  name: 'diversos_resumo',
}

export const ROUTE_CARGA_TOTAL = {
  path: '/carga_total',
  name: 'carga_total',
}

export const ROUTE_IMPRESSAO_PEDIDO = {
  path: '/impressao_pedido',
  name: 'impressao_pedido',
}

export const ROUTE_SINCRONIZAR_ENVIAR = {
  path: '/sincronizar_enviar',
  name: 'sincronizar_enviar',
}